module.exports = __webpack_public_path__ + "static/media/img_Characterdesign-Junior-04Merit_Prize_J08.11823d84.png";